import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Typography } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";

import { useStore } from "../../store";
import { BackdropPanel, Icon } from "../../components";
import { MuiBackdropButton } from "../../components/BackdropPanel/style";
import { getWebBridge } from "../../utils/webBridge";
import { TranslationJSX } from "../../utils/Translation";
import { updateDownloadCount } from "../../api";

const DetailPanelInstall = () => {
  const {
    appStore: {
      apiHeaderState: { token },
    },
    feedStore: { onUpdateDownloadCounts },
    detailStore: {
      installState: { id, isInstall },
      onInstallProgress,
      onInstallComplete,
    },
  } = useStore();

  useEffect(() => {
    getWebBridge({ name: "onInstallProgress", callBack: onInstallProgress });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!id) return;

    // download count api
    updateDownloadCount({ id, token });
    // update download count
    onUpdateDownloadCounts(id);
  }, [id, token, onUpdateDownloadCounts]);

  const handleOnInstallComplete = () => {
    if (!id) return null;
    // install complete project
    onInstallComplete(id);
  };

  const InstallMessage = () => {
    if (!isInstall) return null;

    // install complete 경우 2s 후 자동으로 onInstallComplete 실행
    setTimeout(handleOnInstallComplete, 2000);

    return (
      <React.Fragment>
        <Icon name="done" size={80} />
        <Typography variant="body2">
          <TranslationJSX locoKey="feed_downloading_guide_msg" />
        </Typography>
        <MuiBackdropButton onClick={handleOnInstallComplete}>
          <TranslationJSX locoKey="button_ok" />
        </MuiBackdropButton>
      </React.Fragment>
    );
  };

  return (
    <BackdropPanel isOpen={isInstall} style={{ zIndex: zIndex.snackbar }}>
      <InstallMessage />
    </BackdropPanel>
  );
};

export default observer(DetailPanelInstall);
